



































































































































































import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { checkPermissions } from '@/directives/permissionDirective'
import { ADMColumn } from '@/interfaces/adm-columns.interface'
import { Filter } from '@/interfaces/filter.interface'
import { APIPagination } from '@/models/api/pagination.model'
import moment from 'moment'
import { Component, Vue, Watch } from 'vue-property-decorator'
import WhitelistOneShotModal from '../WhitelistOneShot/WhitelistOneShotModal.vue'
import WhiteListOneShotList from '../WhitelistOneShot/WhiteListOneShotList.vue'

@Component({
    components: {
        ConfirmDialog,
        WhitelistOneShotModal,
        WhiteListOneShotList
    }
})
export default class WhitelistOneShot extends Vue {
    loading = false
    mainTitle = 'Whitelist One Shot'
    filters: Filter[] = []
    dateFilter: string[][] = []
    filterList: Filter[] = []
    formData: {msisdn?: string | undefined | null} = {}
    selectedRows = []
    selectRows = false
    data: object[] = []
    rowsPerPage = 15
    permissionPrefix = 'oneshot_whitelist'
    sortBy = 'msisdn'
    sortByDesc = false

    pagination: APIPagination = {
        currentPage: 1,
        total: 0,
        nextPage: null,
        previousPage: null
    }

    uploadFromFile = {
        active: false,
        mode: 'Add',
        valid: false,
        uploadfile: null,
        statementDate: '',
        providerId: null
    }

    chipFile = false

    customColums: ADMColumn[] = []
    columns: ADMColumn[] = [
        {
            text: 'Msisdn',
            value: 'msisdn',
            sortable: true
        },
        {
            text: 'Actions',
            width: '100px',
            customField: {
                type: 'options',
                hideAll: false
            }
        }
    ]

    statementEdit ={}

    @Watch('filters')
    onFiltersChange () {
        if (this.filters.length === 0) this.filterHandler()
    }

    // METHODS

    checkPermision (permission: string) {
        return !!checkPermissions(permission)
    }

    addFilter () {
        if (this.filters.length === 0) {
            this.filters.push(JSON.parse(JSON.stringify(this.filterList[0])))
        }
    }

    removeFilter (filterIndex?: number) {
        this.filters = this.filters.filter((filter, index) => index !== filterIndex)
        this.formData = {}
        // this.dateFilter = this.dateFilter.filter((filter, index) => index !== filterIndex)
        this.$forceUpdate()
    }

    updateFilter (index: number, newFilter?: string) {
        const foundFilter = this.filterList.find(filter => filter.value === newFilter)
        if (foundFilter) this.filters[index] = JSON.parse(JSON.stringify(foundFilter))
        this.$forceUpdate()
    }

    newLimitHandler (val: number) {
        this.rowsPerPage = val
        this.pagination = {
            currentPage: 1,
            total: 0,
            nextPage: null,
            previousPage: null
        }
        this.loadData()
    }

    paginationTable (val: number) {
        this.pagination.currentPage = val
        this.loadData()
    }

    getMonthNow () {
        return moment().format('YYYY-MM').toString()
    }

    filterHandler () {
        this.pagination = {
            currentPage: 1,
            total: 0,
            ...this.formData,
            nextPage: null,
            previousPage: null
        }
        this.loadData()
    }

    closeModal () {
        this.statementEdit = {}
        this.uploadFromFile.active = false
    }

    deleteCsv () {
        this.statementEdit = {}
        this.uploadFromFile.active = true
        this.uploadFromFile.mode = 'Delete'
        this.uploadFromFile.uploadfile = null
        this.uploadFromFile.statementDate = ''
        this.uploadFromFile.providerId = null
        this.chipFile = false
    }

    importCsv () {
        this.statementEdit = {}
        this.uploadFromFile.active = true
        this.uploadFromFile.mode = 'Import'
        this.uploadFromFile.uploadfile = null
        this.uploadFromFile.statementDate = ''
        this.uploadFromFile.providerId = null
        this.chipFile = false
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    editField (field: any) {
        this.statementEdit = field
        this.uploadFromFile.active = true
        this.uploadFromFile.mode = 'Edit'
        this.uploadFromFile.uploadfile = null
        this.chipFile = true
    }

    loadStatementList (sort: { sortBy: string; sortByDesc: boolean }) {
        if (sort) {
            this.sortBy = sort.sortBy
            this.sortByDesc = sort.sortByDesc
        }
        this.loadData()
    }

    loadData () {
        this.loading = true
        this.filters.forEach((filter, i) => {
            if (filter.type === 'text') {
                filter.queryValue = this.dateFilter[i]
            }
        })
        const msisdn = this.userData.msisdn?.msisdn || this.formData.msisdn
        this.$store.dispatch('getWhitelistOneShotPaginate', {
            page: this.pagination.currentPage,
            filters: this.filters,
            limit: this.rowsPerPage,
            msisdn: msisdn,
            sortBy: this.sortBy ?? '',
            sort: this.sortByDesc ? 'asc' : 'desc'
        })
            .then(resp => {
                if (resp?.status === 200) {
                    this.pagination = { ...this.$store.state.WhitelistOneShotStore.whitelistOneShotPaginate }
                    this.data = this.$store.state.WhitelistOneShotStore.whitelistOneShotPaginate.results || []
                    if (this.pagination.results) delete this.pagination.results

                    if (!this.pagination?.currentPage) this.pagination.currentPage = 1

                    this.loading = false
                }
            })
    }

    get userData () {
        return this.$store.state.AuthStore.auth.user
    }

    getFilters () {
        this.filterList.push({
            text: 'msisdn',
            type: 'text',
            value: 'msisdn',
            queryValue: ''
        })
    }

    downloadFile () {
        this.$store.dispatch('downloadWhitelistOneShotFile')
            .then(resp => {
                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    const blob = new Blob([resp.data], { type: 'text/csv' })
                    const url = window.URL.createObjectURL(blob)
                    const a = document.createElement('a')
                    a.href = url
                    a.download = 'whitelist-one-shot.csv'
                    document.body.appendChild(a)
                    a.click()
                    document.body.removeChild(a)
                }
            })
    }

    async mounted () {
        this.columns.forEach(column => {
            if (column.customField) this.customColums.push(column)
        })
        this.getFilters()
        this.loadData()
    }
}
